import { Injectable } from '@angular/core';
import { select, Store } from '@ngrx/store';
import {
    EditedPhotoData,
    Photo,
    SelectedPhotoData
} from '@classifieds-sell/trademe-core-ui';
import {
    SaveDraft,
    ValidationResult,
    UpdateCurrentStep,
    CategoryEnum,
    ListingRequest
} from 'libs/datalayer/src';
import * as DraftActions from './draft.actions';
import * as DraftFeature from './draft.reducer';
import * as DraftSelectors from './draft.selectors';
import {
    PropertyAgentContactDetailsType
} from 'libs/property-ui/src/lib/models/property-agent-contact-details/property-agent-contact-details-model';

@Injectable()
export class DraftFacade {
    state$ = this.store.pipe(select(DraftSelectors.getState));
    draftLoaded$ = this.store.pipe(select(DraftSelectors.getDraftLoaded));
    draftData$ = this.store.pipe(select(DraftSelectors.getDraftData));
    validation$ = this.store.pipe(select(DraftSelectors.getValidationSchema));
    validationResults$ = this.store.pipe(
        select(DraftSelectors.getValidationResults)
    );
    validateListingResponse$ = this.store.pipe(
        select(DraftSelectors.validateListingResponse)
    );
    listingActionLoading$ = this.store.pipe(
        select(DraftSelectors.getListingActionLoading)
    );
    listingActionResponse$ = this.store.pipe(
        select(DraftSelectors.getListingActionResponse)
    );

    constructor(private store: Store<DraftFeature.DraftPartialState>) {}

    init(categoryId: CategoryEnum, subCategory: string, listingId?: number) {
        this.store.dispatch(
            DraftActions.getDraft({ categoryId, subCategory, listingId })
        );
    }

    updateDraftData(draftData: any) {
        this.store.dispatch(DraftActions.updateDraftData({ draftData }));
    }

    updateValidationResults(validationResult: ValidationResult) {
        this.store.dispatch(
            DraftActions.updateValidationResult({ validationResult })
        );
    }

    saveDraft(draft: SaveDraft) {
        this.store.dispatch(DraftActions.saveDraft({ draft }));
    }

    resetLoadingStatus() {
        this.store.dispatch(DraftActions.resetSaveDraftLoadingStatus());
    }

    makeListingAction(listingRequest: ListingRequest) {
        this.store.dispatch(DraftActions.makeListingAction({ listingRequest }));
    }

    // TODO: Should remove this, Not used anywhere
    // Backend as well
    validateListing() {
        this.store.dispatch(DraftActions.validateListing());
    }

    addPhotoToDraftData(
        photo: Photo,
        selectedPhotoData: SelectedPhotoData,
        parentProperty: string
    ) {
        this.store.dispatch(
            DraftActions.addPhotoToDraftData({
                photo,
                selectedPhotoData,
                parentProperty
            })
        );
    }

    addAgentPhotoToDraftData(
        photo: Photo,
        selectedPhotoData: SelectedPhotoData,
        agenttContactDetailsType: PropertyAgentContactDetailsType,
        parentProperty: string
    ) {
        this.store.dispatch(
            DraftActions.addAgentPhotoToDraftData({
                photo,
                selectedPhotoData,
                agenttContactDetailsType,
                parentProperty
            })
        );
    }

    removeAgentPhotoFromDraftData(agenttContactDetailsType: PropertyAgentContactDetailsType, parentProperty: string) {
        this.store.dispatch(
            DraftActions.removeAgentPhotoFromDraftData({ agenttContactDetailsType, parentProperty })
        );
    }

    updatePhotosInDraftData(photos: Photo[], parentProperty: string) {
        this.store.dispatch(
            DraftActions.updatePhotosInDraftData({ photos, parentProperty })
        );
    }

    updateTransformPhotoDataToDraftData(
        editedPhotoData: EditedPhotoData,
        parentProperty: string
    ) {
        this.store.dispatch(
            DraftActions.updateTransformPhotoDataToDraftData({
                editedPhotoData,
                parentProperty
            })
        );
    }

    updateCurrentStep(currentStep: UpdateCurrentStep) {
        this.store.dispatch(DraftActions.updateCurrentStep({ currentStep }));
    }

    resetPackageCodeIfNeeded({isRelist, isAgent}:{isRelist: boolean, isAgent: boolean}) {
        this.store.dispatch(DraftActions.resetPackageCodeIfNeeded({isRelist, isAgent}));
    }
}
